// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { LongWriteActivityAnswer } from './LongWriteActivityAnswer'
import {
  LongWriteActivityAnswerFromJSON,
  LongWriteActivityAnswerFromJSONTyped,
  LongWriteActivityAnswerToJSON,
} from './LongWriteActivityAnswer'

/**
 *
 * @export
 * @interface LongWriteActivityResult
 */
export interface LongWriteActivityResult {
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResult
   */
  activityId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResult
   */
  activityTemplate?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResult
   */
  displayCategory?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResult
   */
  displayTopic?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResult
   */
  activityResultId?: string | null
  /**
   *
   * @type {string}
   * @memberof LongWriteActivityResult
   */
  userTitle?: string | null
  /**
   *
   * @type {number}
   * @memberof LongWriteActivityResult
   */
  userTargetWordCount?: number
  /**
   *
   * @type {Date}
   * @memberof LongWriteActivityResult
   */
  lastUpdatedDate?: Date
  /**
   *
   * @type {Array<LongWriteActivityAnswer>}
   * @memberof LongWriteActivityResult
   */
  answers?: Array<LongWriteActivityAnswer> | null
}

/**
 * Check if a given object implements the LongWriteActivityResult interface.
 */
export function instanceOfLongWriteActivityResult(value: object): boolean {
  let isInstance = true

  return isInstance
}

export function LongWriteActivityResultFromJSON(
  json: any,
): LongWriteActivityResult {
  return LongWriteActivityResultFromJSONTyped(json, false)
}

export function LongWriteActivityResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LongWriteActivityResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    activityId: !exists(json, 'activityId') ? undefined : json['activityId'],
    activityTemplate: !exists(json, 'activityTemplate')
      ? undefined
      : json['activityTemplate'],
    displayCategory: !exists(json, 'displayCategory')
      ? undefined
      : json['displayCategory'],
    displayTopic: !exists(json, 'displayTopic')
      ? undefined
      : json['displayTopic'],
    activityResultId: !exists(json, 'activityResultId')
      ? undefined
      : json['activityResultId'],
    userTitle: !exists(json, 'userTitle') ? undefined : json['userTitle'],
    userTargetWordCount: !exists(json, 'userTargetWordCount')
      ? undefined
      : json['userTargetWordCount'],
    lastUpdatedDate: !exists(json, 'lastUpdatedDate')
      ? undefined
      : new Date(json['lastUpdatedDate']),
    answers: !exists(json, 'answers')
      ? undefined
      : json['answers'] === null
        ? null
        : (json['answers'] as Array<any>).map(LongWriteActivityAnswerFromJSON),
  }
}

export function LongWriteActivityResultToJSON(
  value?: LongWriteActivityResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    activityId: value.activityId,
    activityTemplate: value.activityTemplate,
    displayCategory: value.displayCategory,
    displayTopic: value.displayTopic,
    activityResultId: value.activityResultId,
    userTitle: value.userTitle,
    userTargetWordCount: value.userTargetWordCount,
    lastUpdatedDate:
      value.lastUpdatedDate === undefined
        ? undefined
        : value.lastUpdatedDate.toISOString(),
    answers:
      value.answers === undefined
        ? undefined
        : value.answers === null
          ? null
          : (value.answers as Array<any>).map(LongWriteActivityAnswerToJSON),
  }
}
